// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__aWzNB","myModalContent":"MyModal_myModalContent__-phwh","active":"MyModal_active__ka8dH"};